module.exports = __webpack_public_path__ + "assets/imgs/logos/uber.d450becda407d91dfd596d8a9e910db7.svg";